export default __webpack_public_path__ + "static/media/intro.b640c7f4.jpg";